import { roleCategories } from 'utils/constants';

export const routeMaps = {
    [roleCategories.SERVICERS]: [
        'dashboard',
        'subscriptions',
        'investors',
        'sent-subscriptions',
        'investors-list',
        'sgp-companies',
        'promoters',
        'servicer-users',
        'provider-users',
        'promoter-users',
        'distributors',
        'networks',
        'fund-management',
        'fund-calls',
        'closings',
        'distributions',
        'reporting',
        'statements',
        'direct-debit-to-funds',
        'transfer-to-funds',
        'sent-messages',
    ],
    [roleCategories.PROVIDERS]: ['dashboard', 'subscriptions', 'investors', 'provider-users'],
    [roleCategories.PROMOTERS]: [
        'dashboard',
        'subscriptions',
        'investors',
        'investors-list',
        'promoter-users',
        'distributors',
        'direct-debit-to-funds',
        'transfer-to-funds',
    ],
    [roleCategories.DISTRIBUTORS]: [
        'homepage',
        'dashboard',
        'subscriptions',
        'investors',
        'investors-list',
        'distributor-users',
        'distributor-documents',
        'distributor-remunerations',
        'reporting',
        'communication',
        'direct-debit-to-funds',
        'transfer-to-funds',
        'sent-messages',
    ],
    [roleCategories.ADMIN_DISTRIBUTORS]: [
        'homepage',
        'dashboard',
        'subscriptions',
        'investors',
        'investors-list',
        'distributor-users',
        'distributor-documents',
        'distributor-remunerations',
        'reporting',
        'communication',
        'direct-debit-to-funds',
        'transfer-to-funds',
        'sent-messages',
    ],
    [roleCategories.INVESTORS]: [
        'homepage',
        'portfolio',
        'investor-account',
        'investor-documents',
        'investor-messages',
    ],
};
